import { useHasOrganizationPermission } from 'sierra-client/hooks/use-permissions'

export function useIsCreateAccessible(): boolean {
  return useHasOrganizationPermission('ACCESS_EDITOR')
}
